const Config = {
    CasUrl: "https://sso.dufe.edu.cn",
    CustomCode: "kb_dconline",
    DefaultBatch: "",
    MaxWeek: parseInt(process.env.REACT_APP_MaxWeek!), // 最大周数,
    LiveUrl: process.env.REACT_APP_LiveUrl!,
    LiveUrlClient: process.env.REACT_APP_LiveUrl_Client!,
    ApiHost: process.env.REACT_APP_API_HOST!,
    WsHost: process.env.REACT_APP_WS_HOST!,
    QiNiuDownloadUrl: "https://niu.edufe.com.cn",
    QiNiuDownloadUrlResource: "https://niukczy.edufe.com.cn",
    QiNiuUploadUrl: "https://up-z1.qiniup.com"
};

export default Config;
